// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

// This file is used for container builds. Values with __PLACEHOLDER__ tokens
// are substituted at container startup by docker-entrypoint.sh via sed.
// For local development, use environment.dev.ts via `ng serve --configuration=dev`.
export const environment = {
  production: '__PRODUCTION__',
  baseUrl: '__BASE_URL__',
  infraBaseUrl: '__INFRA_BASE_URL__',
  domainBaseUrl: '__DOMAIN_BASE_URL__',
  mastersBaseUrl: '__MASTERS_BASE_URL__',
  transactionBaseUrl: '__TRANSACTION_BASE_URL__',
  reportBaseUrlLambda: '__REPORT_BASE_URL_LAMBDA__',
  reportBaseUrlEKS: '__REPORT_BASE_URL_EKS__',
  captchaKey: '__CAPTCHA_KEY__',
  emulateUrl: '__EMULATE_URL__',
  launchDarklyClientKey: '__LAUNCH_DARKLY_CLIENT_KEY__',
  dummy_pswd: '__DUMMY_PSWD__',
};
